<div class="nim__content-area relative">
  <div class="flex align-end">
    <div class="h3 bold gray-40">Terms &amp; Conditions</div>
    <div class="flex-auto right">
      <div class="h5">1.877.224.9692</div>
    </div>
  </div>
  <div class="touch-table__wrapper pr2">
    <div class="card bg-white border border-navy-87 mt2 width100">
      <div class="p3 border-radius-tr border-radius-br relative">
        <div id="termAndConditionText" [innerHTML]="termAndConditionText | async">
        </div>
        <div class="h4 mt2">By logging in you agree that you have read and agree to these terms.
        </div>
      </div>
    </div>
  </div>
</div>
<div class="nim__sidebar">
  <div class="nim__sidebar__top no-padding">
  </div>
  <div class="nim__sidebar__bottom">
    <div class="button-group is-vertical">
    </div>
  </div>
  <div class="nim__sidebar__global">
    <div nc-global-navigation [isBackEnabled]="true" [isHomeEnabled]="true"></div>
  </div>
</div>
